export const AVATAR_COLORS = [
  '#4A6FA5',
  '#6B4FBB',
  '#4FAF8C',
  '#B85C38',
  '#C4A44A',
  '#7A5E9E',
  '#3D8A7A',
];

export function avatarColor(name, userColor) {
  if (userColor) return userColor;
  const code = (name || '').charCodeAt(0) || 0;
  return AVATAR_COLORS[code % AVATAR_COLORS.length];
}

export function avatarLetter(name) {
  return ((name || '?').charAt(0) || '?').toUpperCase();
}

export function fmtDur(ms) {
  if (!ms || ms <= 0) return '0s';
  const totalSec = Math.floor(ms / 1000);
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return m > 0 ? `${m}m ${s}s` : `${s}s`;
}

export function sessionTimeMs(user, endedOn) {
  const entries = Object.values((user && user.intIds) || {});
  if (!entries.length) return 0;
  const first = entries.reduce((a, b) =>
    a.registeredOn < b.registeredOn ? a : b
  );
  const last = entries.reduce((a, b) =>
    (b.leftOn || 0) > (a.leftOn || 0) ? b : a
  );
  const endRef = endedOn || Date.now();
  return Math.max(0, (last.leftOn || endRef) - first.registeredOn);
}

export function isDefaultPresentation(name) {
  if (!name) return true;
  const n = String(name).toLowerCase();
  return n === 'default.pdf' || n === 'default';
}

export function groupPresentations(slides) {
  const list = slides || [];
  const seen = new Map();
  list
    .filter((s) => !isDefaultPresentation(s.presentationName))
    .forEach((s) => {
      const key = s.presentationId || s.presentationName;
      if (!seen.has(key)) {
        seen.set(key, {
          key,
          name: s.presentationName || 'Untitled',
          slides: 0,
        });
      }
      seen.get(key).slides += 1;
    });
  return Array.from(seen.values());
}
